export default __webpack_public_path__ + "static/media/o_wdt_c_1_2.eba4a11c.mp3";